import { Footer, GradientBg, Header } from "../components"
import type { NextPage } from "next"

const Terms: NextPage = () => {
  return (
    <>
      <GradientBg />
      <Header />
      <div className="relative mx-auto py-16 lg:py-32 px-4 prose prose-lg prose-a:text-primary hover:prose-a:text-primaryHover">
        <div className="text-center">
          <h1>Coverdash Terms and Conditions</h1>
        </div>
        <div className="mt-16">
          <p>
            PLEASE READ THESE TERMS AND CONDITIONS (“Terms”) BEFORE USING THIS
            SITE. By continuing to access or use Coverdash's website, data,
            information, products, applications, or services (collectively
            “Services”), you acknowledge that you have read and understand these
            Terms and agree to be bound by them. If you do not accept or
            understand all of these Terms, do not access or use this site and
            cease your current access.
          </p>
          <p>
            Before you click on the “Continue” button or use our services, read
            these terms carefully. By clicking on the “Continue” button or using
            our Services, you are agreeing to be bound by and are becoming a
            party to these terms. You represent and warrant that you have the
            authority to enter into these terms on behalf of any group or entity
            you represent. You hereby covenant to ensure that all users that
            gain access to our services from you are bound by these terms. If
            you do not agree to all of these terms, then do not click “Continue”
            and do not access and/or use our services.
          </p>
          <p>
            Additionally, by clicking "Continue", you agree to transact with us
            electronically. This means you agree to receive electronically all
            disclosures, communications, notices and other information that we
            may send to you or be required to send to you under applicable law
            or otherwise pursuant to the terms and conditions set forth below.
          </p>
          <p>
            PLEASE READ THESE TERMS CAREFULLY TO ENSURE THAT YOU UNDERSTAND EACH
            PROVISION. THESE TERMS CONTAIN A MANDATORY INDIVIDUAL ARBITRATION
            AND CLASS ACTION/JURY TRIAL WAIVER PROVISION THAT REQUIRES THE USE
            OF ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER
            THAN JURY TRIALS OR CLASS ACTIONS.
          </p>
          <h5 className="font-bold">1. Conditions of Service.</h5>
          <p>
            Your use of this website is also subject to our Privacy Policy and
            Compensation Disclosure (“Additional Terms”). By continuing to
            access or use the Services, you acknowledge that you have read and
            understand these Additional Terms and agree to be bound by them as
            well.
          </p>
          <p>
            As used in the Terms and Additional Terms, “Coverdash” refers to
            Coverdash, Inc. and Coverdash Insurance Services, LLC either
            collectively or individually, as the case may be.
          </p>
          <p>
            You warrant that you are at least 18 years of age and can enter into
            binding contracts for insurance or other goods. Persons less than 18
            years of age may not use this site and must leave immediately.
          </p>
          <p>
            You further warrant that all information you provide about yourself
            or your organization is true and complete information. You agree to
            promptly notify Coverdash of any changes in the information provided
            about yourself or your organization or any other material changes
            that could impact your use of the Services.
          </p>
          <p>
            You agree that any document or electronic information delivered
            through the website by “clicking” on the designated spaces in or
            relating to such document shall be deemed to be “in writing” and to
            have been “signed” and delivered for all purposes by you. Any record
            of such confirmation (including, without limitation, electronic
            records) shall be deemed to be “in writing.” You further agree that
            you shall not contest the legally binding nature, validity or
            enforceability of any document or confirmation based on the fact
            that it has been executed by “clicking” on the designated spaces and
            expressly waives any and all rights you may have to assert such a
            claim.
          </p>
          <p>
            You further agree: (i) to comply with applicable U.S. federal,
            state, and local laws and regulations regarding the transmission of
            any information obtained from the Services; (ii) not to use the
            Services for false, fraudulent or illegal purposes; (iii) not to use
            any device, software or similar technology that interferes or
            disrupts the operation of this site; and (iv) to comply with the
            authorized use of and entry into Coverdash's systems and Services.
          </p>
          <h5 className="font-bold">2. Insurance Services.</h5>
          <p>
            You are not required to use Coverdash for insurance brokerage
            services in order to obtain an account and use Coverdash's software.
            You may use the software for free. However, if you choose to use
            Coverdash's insurance brokerage services (“Insurance Brokerage
            Services”), you agree to: (i) designate Coverdash as your broker of
            record or agent of record; (ii) authorize Coverdash to communicate
            such designation as broker or agent of record to any insurance
            carrier, your prior insurance producer, and any other person or
            entity Coverdash determines should be advised; (iii) work
            exclusively with Coverdash for such Insurance Brokerage Services
            unless we have otherwise expressly agreed; and (iv) permit Coverdash
            to receive any commission or other form of compensation that any
            insurance carrier or affinity partner agrees to pay to Coverdash in
            connection with the provision of Insurance Brokerage Services. For
            further information regarding Coverdash's compensation, please see
            our Compensation Disclosure.
          </p>
          <h5 className="font-bold">3. Intellectual Property Ownership.</h5>
          <p>
            This website, including but not limited to its trademarks, trade
            names, service marks, content, materials, designs, text,
            photographs, video, audio and graphics (collectively “Content”),
            belong to Coverdash or to other parties. No one is authorized to use
            or alter any of the Content in any manner without the prior written
            permission of the owner of the Content.
          </p>
          <p>
            The Content is protected by U.S. and international copyright law and
            treaties, and shall not be transmitted, broadcast, copied, adapted,
            displayed, reproduced, republished, uploaded, downloaded, posted,
            distributed, performed or otherwise used without the prior express
            permission of Coverdash. All Content, databases and other
            intellectual property rights associated with the Services, whether
            registered or unregistered, and related goodwill, are proprietary
            rights of Coverdash. Your use of and access to this site does not
            grant you a license or any right to use any of the Content.
          </p>
          <p>
            Modification of any Content or materials displayed on the website or
            the use of any materials displayed for any other purpose is a
            violation of the copyrights and other proprietary rights of
            Coverdash and is prohibited.
          </p>
          <h5 className="font-bold">4. Restrictions on Use.</h5>
          <p>
            You agree to use the Services solely for your own personal use and
            benefit or for that of your organization. You may not use this site
            or the Services for any commercial, financial or other similar
            purpose without the prior written consent of Coverdash.
          </p>
          <h5 className="font-bold">
            5. Consent for Advertising or Marketing Purposes.
          </h5>
          <p>
            As consideration for use of the Services, you grant Coverdash a
            non-exclusive, royalty-free, perpetual, irrevocable license and
            right to publicly display, distribute, reproduce and use your name,
            photo, likeness, business affiliation or similar information
            throughout the world in any media solely as part of the features of
            the Services, including as part of Coverdash's advertising or
            marketing.
          </p>
          <h5 className="font-bold">6. Disclaimer of Warranties — General.</h5>
          <p>
            USE OF THE SERVICES, THE CONTENT AND ANY MATERIALS OBTAINED THROUGH
            YOUR USE OF THE SERVICES IS AT YOUR OWN RISK. COVERDASH MAKES NO
            WARRANTY OF ANY KIND REGARDING THIS WEBSITE, THE SERVICES AND/OR THE
            CONTENT WHICH ARE PROVIDED “AS-IS,” “AS AVAILABLE” AND “WITH ALL
            FAULTS.” COVERDASH EXPRESSLY DISCLAIMS ANY REPRESENTATION OR
            WARRANTY THAT THIS WEBSITE WILL BE ERROR-FREE, SECURE, OR
            UNINTERRUPTED. COVERDASH FURTHER DISCLAIMS ANY WARRANTY AS TO THE
            ACCURACY, RELIABILITY, ADEQUACY, COMPLETENESS OR TIMELINESS OF ANY
            OF THE CONTENT ON THIS WEBSITE, AND FURTHER EXPRESSLY DISCLAIMS
            LIABILITY RESULTING FROM OR ARISING OUT OF ANY ERRORS OR OMISSIONS
            CONTAINED IN THE INFORMATION OR MATERIALS ACCESSED ON OR THROUGH
            THIS WEBSITE.
          </p>
          <p>
            COVERDASH EXPRESSLY DISCLAIMS ALL WARRANTIES AND CONDITIONS,
            INCLUDING IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, EXCEPT TO
            THE EXTENT SUCH WARRANTIES ARE REQUIRED BY APPLICABLE LAW. COVERDASH
            DOES NOT UNDERTAKE ANY OBLIGATION OR RESPONSIBILITY TO UPDATE OR
            AMEND ANY CONTENT OR OTHER INFORMATION PUBLISHED THROUGH THE
            SERVICES.
          </p>
          <p>
            SOME JURISDICTIONS DO NOT ALLOW THE DISCLAIMER OF IMPLIED
            WARRANTIES, SO THIS WARRANTY DISCLAIMER MAY NOT APPLY IN WHOLE OR IN
            PART TO YOU.
          </p>
          <h5 className="font-bold">7. Limitation of Liability.</h5>
          <p>
            UNDER NO CIRCUMSTANCES WILL COVERDASH BE LIABLE FOR ANY LOSS OR
            DAMAGES INCLUDING, WITHOUT LIMITATION, GENERAL, SPECIAL, DIRECT,
            INDIRECT, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY, PUNITIVE OR ANY
            OTHER DAMAGES (SUCH AS LOSS OF PROFITS, LOSS OF GOODWILL, LOSS OF
            USE, LOSS OF DATA, BUSINESS INTERRUPTION, EMOTIONAL DISTRESS OR
            OTHER INTANGIBLE LOSSES) OF ANY KIND WHETHER IN AN ACTION IN
            CONTRACT OR TORT, EVEN IF COVERDASH WAS ADVISED OF THE POSSIBILITY
            OF SUCH DAMAGES, LOSSES OR EXPENSES, ARISING OUT OF OR RELATING IN
            ANY WAY TO: (A) ANY PARTY’S USE OR INABILITY TO USE THE SERVICES,
            THE CONTENT, OR ANY THIRD-PARTY SITE TO WHICH THE SERVICES OR
            CONTENT LINK; (B) ANY FAILURE OF PERFORMANCE, ERROR, OMISSION,
            INTERRUPTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION, COMPUTER
            VIRUS OR LINE OR SYSTEM FAILURE; (C) THE COST OF GETTING SUBSTITUTE
            GOODS OR SERVICES; (D) ANY PRODUCTS, DATA, INFORMATION OR SERVICES
            PURCHASED OR OBTAINED OR MESSAGES RECEIVED OR TRANSACTIONS ENTERED
            INTO, THROUGH OR FROM THE SERVICES; (E) UNAUTHORIZED ACCESS TO OR
            ALTERATION OF YOUR TRANSMISSIONS OR DATA; (F) STATEMENTS OR CONDUCT
            OF ANYONE ON THE SERVICES; (G) THE USE, INABILITY TO USE,
            UNAUTHORIZED USE, PERFORMANCE OR NON-PERFORMANCE OF ANY THIRD PARTY
            SITE; (H) ANY INJURY OR DAMAGES, WHETHER CAUSED BY THE NEGLIGENCE OF
            COVERDASH, ITS EMPLOYEES, SUBCONTRACTORS, AGENTS, SUPPLIERS OR
            OTHERWISE ARISING IN CONNECTION WITH THE SERVICES; (I) ANY FAILURE
            OR DELAY (INCLUDING WITHOUT LIMITATION THE USE OF OR INABILITY TO
            USE ANY COMPONENT OF THIS WEBSITE) TO SUBMIT APPLICATIONS FOR
            INSURANCE PRODUCTS OR SERVICES; (J) ANY ACTIONS ASSOCIATATED WITH
            THE SUBMISSION OR HANDLING OF A CLAIM; (K) ANY ACTIONS ASSOCIATATED
            WITH THE DELAY IN ISSUING ANY CERTIFICATE OF INSURANCE OR THE
            HANDLING OR TRACKING OF CERTIFICATES OF INSURANCE; OR (L) ANY OTHER
            MATTER ARISING OUT OF OR RELATING IN ANY WAY TO THE SERVICES, THE
            CONTENT OR USER CONTENT. COVERDASH IS NOT LIABLE FOR ANY DEFAMATORY,
            OFFENSIVE OR ILLEGAL CONDUCT OF ANY USER.
          </p>
          <p>
            YOUR SOLE REMEDY FOR DISSATISFACTION WITH THE SERVICES OR THE
            CONTENT IS TO DISCONTINUE USING THE SERVICES OR ACCESSING THE
            CONTENT. IN NO EVENT WILL COVERDASH'S TOTAL LIABILITY TO YOU FOR ALL
            DAMAGES, LOSSES OR CAUSES OF ACTION OF ANY KIND OR NATURE WHATSOEVER
            EXCEED THE AMOUNT OF COMMISSION, FEE OR OTHER RENUMERATION EARNED BY
            COVERDASH FOR PROVIDING SERVICES TO YOU FOR THE TWELVE MONTHS PRIOR
            TO THE ALLEGED ACT CAUSING DAMAGES.
          </p>
          <h5 className="font-bold">
            8. Limitation of Liability – Waiver of Unknown Claims.
          </h5>
          <p>
            BY ACCESSING THE SERVICES, YOU UNDERSTAND THAT YOU MAY BE WAIVING
            RIGHTS WITH RESPECT TO CLAIMS THAT ARE AT THIS TIME UNKNOWN OR
            UNSUSPECTED, AND IN ACCORDANCE WITH SUCH WAIVER, YOU ACKNOWLEDGE
            THAT YOU HAVE READ AND UNDERSTAND, AND HEREBY EXPRESSLY WAIVE, THE
            BENEFITS OF SECTION 1542 OF THE CIVIL CODE OF CALIFORNIA, WHICH
            PROVIDES AS FOLLOWS:
          </p>
          <p>
            “A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES
            NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF
            EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE
            MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR,”
          </p>
          <p>
            AND, TO THE EXTENT APPLICABLE, CORRESPONDING RIGHTS UNDER ANY
            SIMILAR LAW OF ANY STATE.
          </p>
          <p>
            IF ANY OF THE FOREGOING LIMITATIONS IN PARAGRAPHS 5 THROUGH 7 ARE
            FOUND TO BE INVALID, COVERDASH'S TOTAL LIABILITY FOR ALL DAMAGES,
            LOSSES, OR CAUSES OF ACTION OF ANY KIND OR NATURE WHATSOEVER SHALL
            BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW.
          </p>
          <h5 className="font-bold">9. Indemnification.</h5>
          <p>
            You agree to defend, indemnify and hold harmless Coverdash and its
            employees, representatives, suppliers and agents from and against
            any and all claims, suits, actions, losses, expenses, demands or
            liabilities, including attorneys' fees and costs, incurred by
            Coverdash in connection with, arising out of or in any way related
            to: (i) your use of the Services or the Content; (ii) your violation
            or alleged violation of the Terms, including, without limitation,
            your violation or alleged violation of any applicable law; (iii)
            your infringement or alleged infringement of any intellectual
            property or other right of any other person or entity; (iv) your
            violation of any other state or federal law or regulation and (v)
            your use of Third-Party Services (defined below). Coverdash reserves
            the right, at its own expense, to assume the exclusive defense and
            control of any matter otherwise subject to indemnification by you,
            and you further agree that you will cooperate fully in the defense
            of any such claims.
          </p>
          <h5 className="font-bold">10. No Legal Advice.</h5>
          <p>
            Any information you access on this website does not constitute a
            recommendation, advice, or complete description of any products,
            Services, or plan.
          </p>
          <p>
            Coverage is provided by various insurance companies and is subject
            to the terms and conditions contained within your specific policy.
            The availability of coverage under your specific policy depends on
            the policy language, the facts of the claim and the law of the
            jurisdiction governing the interpretation of the policy.
          </p>
          <p>
            You must not rely on the information on this website as an
            alternative to legal advice from an attorney nor should you delay
            seeking legal advice, disregard legal advice, or commence or
            discontinue any legal action based on the Services or Content.
          </p>
          <h5 className="font-bold">11. Third-Party Services and Links.</h5>
          <p>
            Coverdash may make branded services of third party vendors available
            to you to help manage your risks (“Third-Party Services”). Although
            these Third-Party Services may be billed through Coverdash,
            Coverdash assumes no liability for the Third-Party Services or any
            disputes associated with any Third-Party Services. Coverdash may
            disclose your name, number, address and business classification to
            our third-party services and you may receive marketing materials
            from Coverdash in relation to our third-party affinity partners.
            Coverdash may also engage in affiliate marketing with our affinity
            partners in which case we may provide our affiliates with your
            personal information.
          </p>
          <p>
            Coverdash may provide, or third parties may provide, links to other
            websites or resources on the Internet. You acknowledge and agree
            that Coverdash is not responsible for the availability of such
            external websites or resources, and Coverdash does not endorse and
            is not responsible or liable for any content, advertising, products,
            or other materials on or available from such websites or resources
            or for any privacy or other practices of the third parties operating
            those websites or resources. Coverdash strongly encourages you to
            review any separate terms of use and privacy policies governing use
            of any third party websites and resources.
          </p>
          <h5 className="font-bold">12. Licensed Entity.</h5>
          <p>
            Coverdash Insurance Services, LLC is licensed as an insurance broker
            or agent in various U.S. states. This website is not intended as a
            solicitation for insurance in any state or province where Coverdash
            is not licensed. Additionally, our affinity partners are in no way
            providing insurance solicitation and even if customers interact with
            our insurance experience directly on affinity partner platforms,
            Coverdash is the licensed entity and insurance broker that is
            providing insurance solicitation and service.
          </p>
          <h5 className="font-bold">13. Applications Do Not Bind Insurance.</h5>
          <p>
            Submitting an application for an insurance quotation through this
            website does not constitute a binder of insurance coverage, although
            it may be used by Coverdash to provide an estimate of the terms,
            conditions, and costs of coverage. A quotation may be subject to
            receipt of additional information or other conditions. In certain
            circumstances, payment may be collected before the policy is bound
            and the policy coverage will only go into effect once a confirmation
            is provided directly. Additionally, there are circumstances where
            payment may be collected on a unbound policy and an insurer may
            reject the policy terms, in that case Coverdash will return funds in
            a timely manner. There may also be circumstances where payment is
            collected before binding and the insurer adjusts pricing, in that
            case Coverdash will credit or debit your account for the remaining
            balance in a timely manner.
          </p>
          <h5 className="font-bold">14. Benchmarking Data.</h5>
          <p>
            Coverdash uses commercially available benchmarking data. Coverdash
            makes no guarantee as to the accuracy of its benchmarking data.
            Moreover, this information is not a quote or an offer of coverage at
            a specified price.
          </p>
          <h5 className="font-bold">15. No Underwriting Services.</h5>
          <p>
            Insurance companies decide to offer, renew, cancel or non-renew
            insurance coverage or otherwise provide customers with the requested
            insurance products. Coverdash does not provide any underwriting
            services and is not responsible or liable for any resulting loss.
          </p>
          <h5 className="font-bold">16. Certificates of Insurance.</h5>
          <p>
            Coverdash may obtain, review and track certificates of insurance for
            you. Coverdash does not independently verify the information in
            these certificates of insurance. You must not rely on the
            information provided by Coverdash as an alternative to legal advice
            from an attorney nor should you delay seeking legal advice,
            disregard legal advice, or commence or discontinue any legal action.
          </p>
          <p>
            You should also understand that a certificate of insurance is an
            informational document that evidences the existence of the policy to
            which it refers. It does not create any coverage or legal
            obligations between the insurance company and the certificate
            holder. Nor does it confer additional insured status to a
            certificate holder. A certificate of insurance does not alter the
            terms of the parties' underlying contract or indemnity agreement.
          </p>
          <p>
            A certificate of insurance typically identifies the agent or broker,
            the insured, and the insurer providing the coverage. It also gives
            basic information about the policy to which it refers, including the
            type of insurance, the policy number, the effective and expiration
            dates of the policy and the liability limits. However, neither the
            insurance company nor the broker who issued the certificate of
            insurance has a duty to inform a certificate holder of inaccuracies
            in, or subsequent changes to, the information contained in a
            certificate of insurance. There is also no duty to inform the
            certificate holder that the policy to which the certificate refers
            has been cancelled or was not renewed.
          </p>
          <p>
            To fully understand the potential coverage provided under a policy,
            a certificate holder should secure a copy of the insurance policy
            and consult with a qualified attorney.
          </p>
          <h5 className="font-bold">17. Policy Summaries.</h5>
          <p>
            The coverage, exclusion, endorsement and other summaries provided by
            Coverdash are for general informational purposes only. They are not
            intended to provide legal advice, and should not be treated as such.
          </p>
          <p>
            Coverdash uses its best efforts to prepare the policy summaries, but
            does not guarantee their accuracy. You should review your actual
            policy to confirm coverage. The availability of coverage under your
            specific policy depends on the policy language, the facts of the
            claim and the law of the jurisdiction governing the interpretation
            of the policy.
          </p>
          <h5 className="font-bold">18. Payments.</h5>
          <p>
            Coverdash does not collect or process credit card information on
            behalf of our customers. Credit card information is collected and
            processed by our payment processor or the insurance carrier
            depending on the policy and which carrier you choose to receive
            coverage from.
          </p>
          <p>
            If your policy is paid using our third party payment processor,
            Ascend:
          </p>
          <p>
            Ascend will bill you based on the information you provide and we
            accept, whether based on monthly payments or pay in full. However,
            if you ultimately choose not to purchase insurance or an insurance
            carrier partner declines your insurance application, Ascend will
            refund you the charged amount. All currency references are in U.S.
            dollars. For clarity, even if you have been billed by Ascend, you
            should not cancel any existing insurance until you have received
            written confirmation from the insurance company to which you are
            applying that your new policy is effective. ASCEND CAN NOT AND WILL
            NOT BE HELD LIABLE FOR ANY DAMAGES THAT RESULT FROM YOUR FAILURE TO
            KEEP EXISTING POLICIES IN EFFECT.
          </p>
          <p>If your policy is paid through a specific insurer:</p>
          <p>
            If the insurer accepts your insurance application, they may accept
            payment via credit card or other electronic payment service. The
            insurer or their third party payment processing partner will bill
            you based on the information you provide. All currency references
            are in U.S. dollars. If the credit card or other payment information
            you provide is invalid for any reason, or if you charge back your
            credit card or other payment mechanism for fees due, the insurer may
            suspend or terminate any or all of the services and products the
            insurer provide to you. The insurer may automatically charge the
            card or other payment mechanism for recurring premiums or other
            recurring fees, the amount of which may change depending on policy
            changes you initiate and other factors approved by insurance
            regulatory authorities. Your policy is for the term specified in
            your insurance contract.
          </p>
          <h5 className="font-bold">
            19. No Modification of Insurance Policy or Coverage.
          </h5>
          <p>
            Unless otherwise expressly stated in writing, nothing contained on
            this website or provided to you by Coverdash should be construed as
            modifying, changing or altering your policy or coverage thereunder.
          </p>
          <h5 className="font-bold">20. A.M. Best Ratings.</h5>
          <p>
            The A.M. Best ratings for insurance companies change frequently.
            Contact Coverdash for the most current rating.
          </p>
          <h5 className="font-bold">21. No Guarantee of Services.</h5>
          <p>
            Coverdash is constantly changing and improving its Services. We may
            add or remove functionalities or features, and we may suspend or
            stop a Service altogether. We may terminate, suspend, change, or
            restrict access to all or any part of the Services, in each case
            without notice or liability.
          </p>
          <p>
            Coverdash also reserves the right to limit the availability of the
            Services or the provision of any Content to any person,
            organization, geographic area or jurisdiction, at any time and in
            its sole discretion.
          </p>
          <h5 className="font-bold">22. Access Outside the United States.</h5>
          <p>
            If you access the Services from outside the United States, you are
            responsible for compliance with foreign and local laws. Coverdash
            does not provide insurance brokerage or other services to
            governments, governmental agencies, businesses, individuals, other
            groups, or any of their agents that are subject to U.S. trade
            sanctions. By using the Services, you represent and warrant that you
            are not subject to any U.S. trade sanctions. Coverdash does not
            provide insurance services, solutions or products to any business
            entity that is based outside of the U.S.
          </p>
          <h5 className="font-bold">23. Termination.</h5>
          <p>
            These Terms, as may be amended from time to time, are effective
            until your account, if applicable, is deactivated by either you or
            Coverdash and you discontinue your use of the Services. Any section
            of the Terms that by their nature is intended to survive termination
            of the Services or your use or access to the Services or the Content
            shall survive such termination.
          </p>
          <h5 className="font-bold">24. Governing Law.</h5>
          <p>
            The laws of the State of California, excluding the conflicts of law
            provisions thereof, will apply to any disputes arising out of or in
            any way related to these Terms or the Services. You acknowledge that
            these Terms may evidence a transaction involving interstate
            commerce. Notwithstanding the foregoing, any arbitration conducted
            pursuant to these Terms shall be governed by the Federal Arbitration
            Act (9 U.S.C. §§ 1-16). The application of the United Nations
            Convention on Contracts for the International Sale of Goods is
            expressly excluded.
          </p>
          <p>
            You agree to submit to the personal jurisdiction of the federal and
            state courts located in San Francisco County, California for any
            actions for which Coverdash retains the right to seek injunctive or
            other equitable relief to prevent the actual or threatened
            infringement, misappropriation or violation of its copyrights,
            trademarks, trade secrets, patents, or other intellectual property
            or proprietary rights, as set forth in the Arbitration section
            below, including any provisional relief required to prevent
            irreparable harm. You further agree that San Francisco County,
            California is the proper forum for any appeal of an arbitration
            award or for trial court proceedings in the event that the
            arbitration provision below is found to be unenforceable.
          </p>
          <h5 className="font-bold">25. Informal Dispute Resolution</h5>
          <p>
            For any dispute with Coverdash, you agree to first contact us at
            legal@Coverdash.com and attempt to resolve the dispute with us
            informally. In the unlikely event that we are not able to resolve
            the dispute after 60 days, we agree that any and all disputes,
            claims or controversies arising out of or relating to these Terms or
            the Additional Terms shall be submitted to JAMS, or its successor,
            for mediation, and if the matter is not resolved through mediation,
            then it shall be submitted to JAMS, or its successor, for final and
            binding arbitration pursuant to the arbitration provision below.
          </p>
          <p>
            Either party may commence mediation by providing to JAMS and the
            other party a written request for mediation, setting forth the
            subject of the dispute and the relief requested. The parties will
            cooperate with JAMS and with one another in selecting a mediator
            from the JAMS panel of neutrals and in scheduling the mediation
            proceedings. The parties agree that they will participate in the
            mediation in good faith and that they will share equally in its
            costs.
          </p>
          <p>
            All offers, promises, conduct and statements, whether oral or
            written, made in the course of the mediation by any of the parties,
            their agents, employees, experts and attorneys, and by the mediator
            or any JAMS employees, are confidential, privileged and inadmissible
            for any purpose, including impeachment, in any arbitration or other
            proceeding involving the parties, provided that evidence that is
            otherwise admissible or discoverable shall not be rendered
            inadmissible or non-discoverable as a result of its use in the
            mediation.
          </p>
          <h5 className="font-bold">26. Arbitration</h5>
          <p>
            READ THIS SECTION CAREFULLY BECAUSE IT REQUIRES THE PARTIES TO
            ARBITRATE THEIR DISPUTES AND LIMITS THE MANNER IN WHICH YOU CAN SEEK
            RELIEF FROM COVERDASH.
          </p>
          <p>
            If the matter is not resolved by informal negotiations or mediation,
            then the matter will proceed to arbitration as set forth below.
          </p>
          <p>
            Any dispute, claim or controversy arising out of or relating to
            these Terms or the Additional Terms or the breach, termination,
            enforcement, interpretation or validity thereof, including the
            determination of the scope or applicability of this agreement to
            arbitrate, shall be determined by arbitration in San Francisco,
            unless otherwise agreed upon by Coverdash. The arbitration shall be
            administered by JAMS pursuant to either its Comprehensive
            Arbitration Rules or Streamlined Arbitration Rules and Procedures
            depending upon the amount of the damages claimed, excluding
            attorneys' fees. Judgment on the award may be entered in any court
            having jurisdiction. This clause shall not preclude parties from
            seeking provisional remedies in aid of arbitration from a court of
            appropriate jurisdiction. Nothing in this paragraph shall be deemed
            as preventing Coverdash from seeking injunctive or other equitable
            relief from the courts as necessary to prevent the actual or
            threatened infringement, misappropriation, or violation of our data
            security, intellectual property rights or other proprietary rights.
          </p>
          <p>
            You agree that regardless of any statute or law to the contrary, any
            claim or cause of action arising out of or related to your use of
            this site, the Services, the Terms or Additional Terms must be filed
            within one (1) year after such claim or cause of action arose.
          </p>
          <p>
            If any provision of the Terms is found by a court of competent
            jurisdiction or arbitrator or arbitration panel to be invalid or
            unenforceable, such provision shall be enforced to the maximum
            extent permissible and the other provisions of the Terms shall
            remain in full force and effect.
          </p>
          <p>
            If any action at law or in equity is necessary to enforce these
            Terms, the prevailing party will be entitled to reasonable fees of
            attorneys, accountants and other professionals, and costs and
            expenses in addition to any other relief to which such prevailing
            party may be entitled.
          </p>
          <h5 className="font-bold">27. No Class Actions.</h5>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, YOU AGREE THAT
            ANY AND ALL DISPUTES, CLAIMS AND CAUSES OF ACTION YOU MAKE AGAINST
            COVERDASH ARISING OUT OF, IN CONNECTION WITH OR IN ANY WAY RELATED
            TO THE SERVICES WILL BE RESOLVED INDIVIDUALLY, WITHOUT RESORT TO ANY
            FORM OF CLASS ACTION, COLLECTIVE ACTION, PRIVATE ATTORNEY GENERAL
            ACTION OR OTHER REPRESENTATIVE PROCEEDING. THIS WAIVER APPLIES TO
            CLASS ARBITRATION, AND, UNLESS COVERDASH AGREES OTHERWISE, THE
            ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE PERSON'S CLAIMS.
          </p>
          <p>
            YOU FURTHER AGREE THAT, BY ENTERING INTO THIS AGREEMENT, YOU AND
            COVERDASH ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO
            PARTICIPATE IN A CLASS ACTION, COLLECTIVE ACTION, PRIVATE ATTORNEY
            GENERAL ACTION, OR OTHER REPRESENTATIVE ACTION.
          </p>
          <h5 className="font-bold">28. Entire Agreements and No Waiver.</h5>
          <p>
            The Terms and Additional Terms (and any terms which are incorporated
            by reference herein or hereinafter implemented) constitute the
            entire agreement between you and Coverdash in connection with your
            use of the Services. The titles contained in the Terms are inserted
            only as a matter of convenience and have no legal or contractual
            effect. You agree that the Terms will not be construed against
            Coverdash by virtue of having drafted them.
          </p>
          <p>
            The failure of Coverdash to enforce any of its rights or act with
            respect to a breach of the Terms by you or others does not
            constitute a waiver of any such rights and will not limit
            Coverdash's rights with respect to such breach or any subsequent
            breaches. No waiver by Coverdash of any of the provisions in the
            Terms will be of any force or effect unless made in writing and
            signed by a duly authorized officer of Coverdash.
          </p>
          <h5 className="font-bold">29. Official Correspondence.</h5>
          <p>
            Official Correspondence may be sent to legal@coverdash.com or via
            postal mail to:
          </p>
          <span className="font-semibold block">Coverdash, Inc.</span>
          <span className="block">1235 Broadway, New York, NY 10001</span>
          <h5 className="font-bold mt-6">30. Modification of Terms</h5>
          <p>
            Coverdash reserves the right to change these Terms from time to time
            and at its sole discretion. The last time these Terms were revised
            is set forth below. Your continued use of Coverdash's website after
            the last revision date indicates your acceptance of any revisions.
          </p>
          <h5 className="font-bold mt-6">31. SMS Communications</h5>
          <p>
            By submitting contact information on this website, you are
            consenting to receive calls, SMS, and emails from Coverdash and its
            affiliates. You certify that you are the owner of the contact
            information provided.
          </p>
          <p>
            You have the right to opt out of receiving SMS communications at any
            time. To opt out, please reply to any text message with the word
            "STOP" or follow the instructions provided in the message. Please
            note that opting out may limit certain functionalities and services
            provided by Coverdash.
          </p>
          <p>
            Standard messaging rates and fees may apply for these SMS
            communications, depending on your mobile carrier and plan.
          </p>
          <p>
            Please review our Privacy Policy for more information on how we
            handle and protect your personal information.
          </p>
          <h5 className="font-bold mt-6">32. Auto Pay Enrollment Disclaimer</h5>
          <p>
            By completing a digital transaction or purchase through Coverdash,
            you automatically authorize our payment processing partner to
            automatically charge the payment method you have selected for
            recurring billing cycles. This authorization covers all current and
            future charges associated with your purchase, with payments
            processed on or about the same day each billing period. You
            acknowledge that you are responsible for maintaining valid payment
            information and may opt out of Auto Pay at any time by contacting
            Coverdash customer support or our payment processing partner
            directly.
          </p>
          <p>
            You understand and agree that failure to maintain a valid payment
            method or to opt out may result in service interruption, and that
            continued use of services constitutes acceptance of these automatic
            payment terms. Coverdash reserves the right to modify the Auto Pay
            terms at any time, and you remain responsible for all outstanding
            balances. By completing any digital transaction, you confirm that
            you have read, understood, and consent to these terms, granting
            explicit authorization for recurring automatic payments.
          </p>
        </div>
        <p className="text-center">Coverdash: Business insurance in a Dash</p>
        <p className="text-center text-xs font-medium">Updated: 10/31/2025</p>
      </div>
      <Footer />
    </>
  )
}

export default Terms
